export class SuccessResponse {
  public success: boolean;
  public message?: string;

  constructor(obj: any = {} as SuccessResponse) {
    this.success = obj.success;
    this.message = obj.message;
  }
}